export const SizeStyleMap: any = {
  small: {
    "--inherit-size": "3.8vmin",
    "line-height": "1.5rem",
    "--modal-line-height": "2rem",
    "--paragraph-margin": "0 0 1.5rem 0",
  },
  medium: {
    "--inherit-size": "4.5vw",
    "line-height": "2rem",
    "--modal-line-height": "2.5rem",
    "--paragraph-margin": "0 0 2rem 0",
  },
  large: {
    "--inherit-size": "5.5vw",
    "line-height": "2.5rem",
    "--modal-line-height": "3rem",
    "--paragraph-margin": "0 0 2.5rem 0",
  },
}

export const SizeNameMap: any = {
  small: "小",
  medium: "中",
  large: "大",
}
